'use client';

import { c as _c } from "react/compiler-runtime";
import { useMemo, useState } from 'react';
import ContributorsList from './contributors-list';
import ContributorsNavigation from './contributors-navigation';
import { splitByCapitalLetterOfLastName, useContributors } from './data';
export function WidgetContributorsPanel() {
  const $ = _c(13);
  const contributors = useContributors();
  let t0;
  if ($[0] !== contributors) {
    t0 = splitByCapitalLetterOfLastName(contributors);
    $[0] = contributors;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const pages = t0;
  const [page, setPage] = useState(0);
  let t1;
  if ($[2] !== page || $[3] !== pages) {
    t1 = pages[page] ?? [];
    $[2] = page;
    $[3] = pages;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const currentPage = t1;
  let t2;
  if ($[5] !== page || $[6] !== pages) {
    t2 = <ContributorsNavigation pages={pages} page={page} onPageChange={setPage} />;
    $[5] = page;
    $[6] = pages;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== currentPage) {
    t3 = <ContributorsList list={currentPage} />;
    $[8] = currentPage;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t2 || $[11] !== t3) {
    t4 = <>{t2}{t3}</>;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
}